import { AbstractControl, ValidatorFn } from '@angular/forms';
import { Moment } from 'moment';

export class DateValidators {

    /**

     * Max date validator. If value of the control is null, it will be considered as valid.

     */
    static maxDate(maxDate: Moment): ValidatorFn {
        const maxDateDate = maxDate.toDate();

        return (control: AbstractControl): { [key: string]: any } | null => {
            if (!control.value) return null;
            const controlDate = new Date(control.value);

            return controlDate > maxDateDate
                ? { maxDate: { value: control.value } }
                : null;


        };
    }


    /**

     * Min date validator. If value of the control is null, it will be considered as valid.

     */
    static minDate(minDate: Moment): ValidatorFn {

        const minDateDate = minDate.toDate();

        return (control: AbstractControl): { [key: string]: any } | null => {
            if (!control.value) return null;


            const controlDate = new Date(control.value);

            return controlDate < minDateDate
                ? { minDate: { value: control.value } }
                : null;


        };
    }

}
